<template>
    <div class="filemanager">
        <file-manager></file-manager>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                
            }
        },
        methods: {
            name() {
                
            }
        },
    }
</script>

<style scoped>
@import url('https://use.fontawesome.com/releases/v5.0.10/css/all.css');
    .filemanager {
        height: 500px;
    }
</style>